/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preset_Save_CancelInputs */

const en_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_transcript_export_preset_save_cancel = /** @type {(inputs: Transcript_Export_Preset_Save_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Transcript_Export_Preset_Save_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_save_cancel = /** @type {((inputs?: Transcript_Export_Preset_Save_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Save_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_save_cancel(inputs)
	if (locale === "de") return de_transcript_export_preset_save_cancel(inputs)
	if (locale === "it") return it_transcript_export_preset_save_cancel(inputs)
	if (locale === "ru") return ru_transcript_export_preset_save_cancel(inputs)
	if (locale === "es") return es_transcript_export_preset_save_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_save_cancel(inputs)
	if (locale === "ja") return ja_transcript_export_preset_save_cancel(inputs)
	if (locale === "hi") return hi_transcript_export_preset_save_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_save_cancel(inputs)
	return en_transcript_export_preset_save_cancel(inputs)
});